module.exports = __webpack_public_path__ + "static/media/delivery-bike-white.c9c960c1.svg";